<template>
  <div class="offline-evaluation">
    <section class="chat-info">
      <div v-show="skillName" class="skill-name">
        技能组名称：
        <span>{{ skillName }}</span>
      </div>
      <div class="consult-time">
        咨询时间：
        <span>{{ new Date(Number(createTime)).toLocaleString() }}</span>
      </div>
    </section>
    <section class="evaluation">
      <div class="capital">请问您对本次咨询是否满意？</div>
      <div class="options">
        <div class="item">
          <div @click="selectGood">
            <img v-show="!isGoodSelected" src="./images/good.png" />
            <img v-show="isGoodSelected" src="./images/good_selected.gif" />
          </div>
          <span>满意</span>
        </div>
        <div @click="selectBad" class="item">
          <div>
            <img v-show="!isBadSelected" src="./images/bad.png" />
            <img v-show="isBadSelected" src="./images/bad_selected.gif" />
          </div>
          <span>不满意</span>
        </div>
      </div>
    </section>
    <footer>
      <bottom-button :text="btnText" :disabled="!canSubmit" @click="submit"></bottom-button>
    </footer>

    <div class="over-lay" v-if="isOverlayVisible"></div>
    <div class="overdue-dialog" v-if="isOverdueDialogVisible">
      <span>您已经评价了哦~</span>
    </div>
  </div>
</template>

<script>
// import { lego } from '@zz-common/lego'
import { kfImEvaluate, getEvaluateInfo } from '@api/resourceApi'
import { toast } from '../../native'
import { queryParams } from '../../lib/utils'

import BottomButton from './BottomButton/BottomButton'

const OPTION_GOOD = 10
const OPTION_BAD = 1
const query = queryParams()

export default {
  name: 'OfflineEvaluation',
  components: {
    BottomButton
  },
  data() {
    return {
      convId: query.convId || this.$route.query.convId,
      skillId: '',
      skillName: '',
      kefuUid: '',
      createTime: 0,
      commented: false,
      score: 0,
      isOverdueDialogVisible: false
    }
  },
  computed: {
    btnText() {
      if (this.commented) {
        return '小熊已收到您的评价！'
      }
      return '确认提交'
    },
    isGoodSelected() {
      return this.score === OPTION_GOOD
    },
    isBadSelected() {
      return this.score === OPTION_BAD
    },
    canSubmit() {
      return (this.isGoodSelected || this.isBadSelected) && !this.commented
    },
    isOverlayVisible() {
      return this.isOverdueDialogVisible || false
    }
  },
  methods: {
    selectGood() {
      if (this.commented) return
      this.score = OPTION_GOOD
    },
    selectBad() {
      if (this.commented) return
      this.score = OPTION_BAD
    },
    submit() {
      if (!this.canSubmit || this.commented) return
      if (this.commented) {
        toast({
          msg: '已经提交了哦',
          style: '1'
        })
        return
      }

      kfImEvaluate({
        convId: this.convId,
        kefuUid: this.kefuUid,
        skillId: this.skillName,
        score: this.score,
        evaluateType: 5
      })
        .then((_data) => {
          this.commented = true
          toast({
            msg: '小熊已收到您的评价！',
            style: '1'
          })
        })
        .catch((err) => {
          console.error(err)
          toast({
            msg: err.errMsg || err,
            style: '2'
          })
        })
    }
  },
  mounted() {
    getEvaluateInfo({
      convId: this.convId
    })
      .then((data) => {
        this.skillId = data.skillId
        this.skillName = data.skillName
        this.kefuUid = data.kefuUid
        this.score = Number(data.score)
        this.createTime = data.createTime

        if (this.score === OPTION_BAD || this.score === OPTION_GOOD) {
          this.isOverdueDialogVisible = true
        }
      })
      .catch((err) => {
        console.error(err)
        toast({
          msg: err.errMsg || err,
          style: '2'
        })
      })
  }
}
</script>

<style scoped lang="less">
  @import 'OfflineEvaluation.less';
</style>
